import React, {useEffect, useState} from 'react';
// import Nav from 'react-bootstrap/Nav';
import {Button, Card, CardBody, CardHeader, Col, Container, Row} from "reactstrap";
import {useHistory} from "react-router-dom";
import character from "../../assets/img/backgrounds/step2Character.png";
import registrationInactive from "../../assets/img/icons/user/card-sidebar/registration.png";
import registrationActive from "../../assets/img/icons/user/card-sidebar/registrationActive.png";
import loginInactive from "../../assets/img/icons/user/card-sidebar/login.png";
import loginActive from "../../assets/img/icons/user/card-sidebar/loginActive.png";
import artworkInactive from "../../assets/img/icons/user/card-sidebar/artWork.png";
import artworkActive from "../../assets/img/icons/user/card-sidebar/artWorkActive.png";
import clip from "../../assets/img/icons/user/clip.png";


const Step3 = (props) => {
    const [activeTab, setActiveTab] = useState("tab1");
    const history = useHistory();
    const [selectAll, setSelectAll] = useState(false);
    const [signUpFields, setSignUpFields] = useState({
        fullName: false,
        email: false,
        dateOfBirth: false,
    });
    const [inputValue, setInputValue] = useState('');


    useEffect(() => {

    }, [])

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        if (name === 'selectAll') {
            setSelectAll(checked);
            setSignUpFields({
                fullName: checked,
                email: checked,
                dateOfBirth: checked,
            });
        } else {
            setSignUpFields((prevState) => ({
                ...prevState,
                [name]: checked,
            }));
            setSelectAll(Object.values(signUpFields).every((value) => value));
        }
    };

    const handleSubmit = () => {

        let fields = [];
        for (const item in signUpFields) {

            if (signUpFields[item]) {
                fields.push(item);
            }
        }

        const loginMethod = ["email"];
        props.setUserData({
            ...props.userData,
            eventData: {...props.userData.eventData, registrationFields: fields, loginMethod: loginMethod}
        });
        history.push("/easy-flow/step4");
    }

    const previous = () => {
        history.goBack();
    }

    return (
        <div>
            <Container>
                <div className="d-flex justify-content-center">
                    <div className="d-none d-lg-block mb--150 ml--10 character">
                        <div className="d-flex">
                            <div className="max-z-index">
                                <img src={character} width={201} />
                            </div>
                            <div className="bubble">
                                <div className="bubble-text position-relative">
                                    <p className="text-break text-center">Hi, Pharetra pelle ntes que mi leo id
                                        est ornare. Libero nunc gravida at mattis. Facilisi
                                        consectetur</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*<Container className="">*/}
                    <Card className="mt--75 innerCard br-60" style={{ display: 'flex', flexDirection: 'row' }}>
                        <CardHeader className="card-headers text-nowrap">
                            <div
                                className="d-flex flex-column justify-content-between h-100 py-3">
                                <div role="button" onClick={() => {
                                    setActiveTab("tab1")
                                }}>
                                    <div>
                                        <img src={activeTab === "tab1" ? registrationActive : registrationInactive}
                                            alt="icon" />

                                    </div>
                                    <div>
                                        <span>Registration <br /> Fields</span>
                                    </div>
                                </div>
                                <div role="button" onClick={() => {
                                    setActiveTab("tab2")
                                }}>
                                    <div>
                                        <img src={activeTab === "tab2" ? loginActive : loginInactive}
                                            alt="icon" />
                                    </div>
                                    <div>
                                        <span>Log In <br /> Method</span>
                                    </div>
                                </div>
                                <div role="button" onClick={() => {
                                    setActiveTab("tab3")
                                }}>
                                    <div>
                                        <img src={activeTab === "tab3" ? artworkActive : artworkInactive} alt="icon" />
                                    </div>
                                    <div>
                                        <span>Custom <br /> Artwork</span>
                                    </div>
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody className="pt-0">
                            <Container className="py-lg-3 card-container">
                                {activeTab === "tab1" &&
                                    <div>
                                        <h1 className='mt-4 pers-head'>
                                            Personal Information
                                        </h1>
                                        <p className='col-8 pers-para'>
                                            Tincidunt nullam auctor iaculis commodo vel lacus urna ut. Scelerisque
                                            duis nunc consectetur cras sed ultricies vestibulum. Nec molestie tortor
                                            placerat tempor.
                                        </p>
                                        <div>
                                            <div className="mb-3">
                                                <input
                                                    className="checkbox-round mx-2"
                                                    type="checkbox"
                                                    id="selectAll"
                                                    name="selectAll"
                                                    checked={selectAll}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label className='radio-label' htmlFor="selectAll">Mark All
                                                    Fields</label>
                                            </div>
                                            <Row>
                                                <Col sm={3}>
                                                    <div>
                                                        <input
                                                            className="checkbox-round mx-2"
                                                            type="checkbox"
                                                            id="fullName"
                                                            name="fullName"
                                                            checked={signUpFields.fullName}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                        <label className='radio-label' htmlFor="fullName">Full
                                                            Name</label>
                                                    </div>
                                                </Col>
                                                <Col sm={3}>
                                                    <div>
                                                        <input
                                                            className="checkbox-round mx-2"
                                                            type="checkbox"
                                                            id="email"
                                                            name="email"
                                                            checked={signUpFields.email}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                        <label className='radio-label' htmlFor="email">Email
                                                            Address</label>
                                                    </div>
                                                </Col>
                                                <Col sm={3}>
                                                    <div>
                                                        <input
                                                            className="checkbox-round mx-2"
                                                            type="checkbox"
                                                            id="dateOfBirth"
                                                            name="dateOfBirth"
                                                            checked={signUpFields.dateOfBirth}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                        <label className='radio-label' htmlFor="dateOfBirth">Date of
                                                            Birth</label>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                }
                                {activeTab === "tab2" &&
                                    <>
                                        <div>
                                            <h2 className='met-head'>
                                                Select your preferred Log In method for your assessment game
                                            </h2>
                                        </div>

                                        <div>
                                            <Row className='mb-3 mt-4'>
                                                <Col sm={3}>
                                                    <div>
                                                        <input
                                                            className="checkbox-round1 mx-2"
                                                            type="checkbox"
                                                            id="field1"
                                                            name="field1"
                                                        // checked={checkboxes.field1}
                                                        // onChange={handleCheckboxChange}
                                                        />
                                                        <label className='radio-label' htmlFor="field1">LinkedIn
                                                            profile</label>
                                                    </div>
                                                </Col>
                                                <Col sm={3}>
                                                    <div>
                                                        <input
                                                            className="checkbox-round1 mx-2"
                                                            type="checkbox"
                                                            id="field2"
                                                            name="field2"
                                                        // checked={checkboxes.field2}
                                                        // onChange={handleCheckboxChange}
                                                        />
                                                        <label className='radio-label' htmlFor="field2">Facebook
                                                            profile</label>
                                                    </div>
                                                </Col>
                                                <Col sm={3}>
                                                    <div>
                                                        <input
                                                            className="checkbox-round1 mx-2"
                                                            type="checkbox"
                                                            id="field3"
                                                            name="field3"
                                                        // checked={checkboxes.field3}
                                                        // onChange={handleCheckboxChange}
                                                        />
                                                        <label className='radio-label' htmlFor="field3">Google </label>
                                                    </div>
                                                </Col>
                                                <Col sm={3}>
                                                    <div>
                                                        <input
                                                            className="checkbox-round1 mx-2"
                                                            type="checkbox"
                                                            id="field3"
                                                            name="field3"
                                                        // checked={checkboxes.field3}
                                                        // onChange={handleCheckboxChange}
                                                        />
                                                        <label className='radio-label' htmlFor="field3">Apple </label>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <div className="mb-3">
                                                <input
                                                    className="checkbox-round mx-2"
                                                    type="checkbox"
                                                    id="selectAll"
                                                    name="selectAll"
                                                // checked={selectAll}
                                                // onChange={handleCheckboxChange}
                                                />
                                                <label className='radio-label' htmlFor="selectAll">Personal Email
                                                    Address</label>
                                            </div>
                                        </div>
                                    </>
                                }
                                {activeTab === "tab3" &&
                                    <>
                                        <div className='mt-5'>
                                            <h2 className='met-head my-5 pt-5  '>
                                                You can download the company logo and intro video below:
                                            </h2>

                                        </div>
                                        <Row>
                                            <Col sm={12} lg={6} className='px-4'>
                                                <div >
                                                    <p className='art-head'>
                                                        Upload Company Logo
                                                    </p>
                                                    <img className='clip-icon ' src={clip} alt="" />
                                                    <input
                                                        className='up-field px-5'
                                                        placeholder='Choose File'
                                                        type="text"
                                                        value={inputValue}
                                                        onChange={handleInputChange}
                                                        style={{ flexGrow: 1 }}
                                                    />
                                                    <Button className='calendar-icon-1 '>
                                                        Delete
                                                    </Button>
                                                </div>
                                            </Col>
                                            <Col sm={12} lg={6} className='px-4'>
                                                <div>
                                                    <p className='art-head'>Upload Intro Video</p>
                                                    <img className='clip-icon ' src={clip} alt="" />
                                                    <input
                                                        className='up-field px-5'
                                                        placeholder='Choose File'
                                                        type="text"
                                                        value={inputValue}
                                                        onChange={handleInputChange}
                                                        style={{ flexGrow: 1 }}
                                                    />
                                                    <Button className='calendar-icon-2 '>
                                                        Delete
                                                    </Button>
                                                </div>

                                            </Col>
                                        </Row>

                                    </>
                                }
                            </Container>
                            <Container className="mt-5">
                                <Row>
                                    <Col sm={12} xs={12} md={3} lg={3}>
                                        <Button className="previous-button text-white w-100" onClick={previous}
                                            color="">Previous</Button>
                                    </Col>
                                    <Col sm={12} xs={12} md={6} lg={6}></Col>
                                    <Col sm={12} xs={12} md={3} lg={3}>
                                        <Button className="nextButton px-sm-0 border-0 text-white px-5 w-100"
                                            color=""
                                            onClick={handleSubmit}
                                        >Next</Button>
                                    </Col>
                                </Row>
                            </Container>
                        </CardBody>
                    </Card>
                    {/*</Container>*/}
                </div>
            </Container>
        </div>
    );
};

export default Step3;


